//Components
import Slider from './components/slider'
import MainMenu from './components/main-menu'
import MainMenuMobile from './components/main-menu-mobile'
import ComponentPageHome from './pages/home'
import ComponentPageBlog from './pages/blog'
import ComponentPageSearch from './pages/search'
import ComponentPageCategory from './pages/category'
import PageInspiracoes from './pages/inspiracoes'
import ComoFunciona from './pages/como-funciona'

export default class App {
  constructor() {
    //Components
    const SliderComponent = document.querySelector('.slider')
    const MainMenuComponent = document.querySelector('.nav-main')
    const MainMenuMobileComponent = document.querySelector(
      '.menu-header-mobile'
    )

    //Pages
    const PageHome = document.querySelector('.home')
    const PageComoFunciona = document.querySelector('.como-funciona')
    const PageCategory = document.querySelector('.internal-blog')
    const PageSearch = document.querySelector('.search')
    const PageBlog = document.querySelector('.blog')
    const PageIspiracao = document.querySelector('.projetos')
    const PageIspiracaoInterna = document.querySelector('.projeto-interna')

    //Load component if necessary
    SliderComponent ? new Slider() : null
    MainMenuComponent ? new MainMenu() : null
    MainMenuMobileComponent ? new MainMenuMobile() : null
    PageHome ? new ComponentPageHome() : null
    PageCategory ? new ComponentPageCategory() : null
    PageSearch ? new ComponentPageSearch() : null
    PageBlog ? new ComponentPageBlog() : null
    PageIspiracao || PageIspiracaoInterna ? new PageInspiracoes() : null
    PageComoFunciona ? new ComoFunciona() : null
  }
}

new App()
